<template>
  <div id="request_return">
    <div class="box_wrap" data-detail="cart_detail">
      <!-- PROGRESS BAR START -->
      <div class="cart_progress">
        <div :class="stageNo === 1 ? 'active' : ''" class="progress_box">
          <p class="cell">
            <span class="fn_mont">{{ `01. 반품 요청` }}</span>
          </p>
        </div>
        <div class="c_icon ico_progress_arrow"></div>
        <div :class="stageNo === 2 ? 'active' : ''" class="progress_box">
          <p class="cell">
            <span class="fn_mont">{{ `02. 수거정보 입력` }}</span>
          </p>
        </div>
        <div class="c_icon ico_progress_arrow"></div>
        <div :class="stageNo === 3 ? 'active' : ''" class="progress_box">
          <p class="cell">
            <span class="fn_mont">{{ `03. 환불금액 확인` }}</span>
          </p>
        </div>
        <div class="c_icon ico_progress_arrow"></div>
        <div :class="stageNo === 4 ? 'active' : ''" class="progress_box">
          <p class="cell">
            <span class="fn_mont">{{ `04. 반품 요청 완료` }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="return_body">
      <ReturnStep1 v-if="stageNo === 1" @nextCall="nextStage" />
      <ReturnStep2
        v-if="stageNo === 2"
        @prevCall="prevStage"
        @nextCall="nextStage"
      />
      <ReturnStep3
        v-if="stageNo === 3"
        @prevCall="prevStage"
        @nextCall="nextStage"
      />
      <ReturnStep4 v-if="stageNo === 4" @nextCall="completeReturn" />
    </div>
    <div v-if="stageNo !== 4" class="return_footer">
      <span class="return_msg">반품 시 안내</span>
      <ul class="desc_wrap">
        <li class="desc_list">
          <span>
            {{
              `박스 개수에 따라 반품 택배비가 청구되오니 가급적 박스 한 개에 반품 요청 상품을 넣어주셔야 합니다.`
            }}</span
          >
        </li>
        <li class="desc_list">
          <span>
            {{
              `반품 요청은 최대 3회까지 가능하나, 경우에 따라 요청 횟수가 제한될 수 있습니다.`
            }}</span
          >
        </li>
        <li class="desc_list">
          <span>{{
            `구매자의 사유로 반품 요청 시 최초 배송비와 반품 배송비를 합산한 왕복 배송비가 청구됩니다.`
          }}</span>
        </li>
        <li class="desc_list">
          <span>{{ `도서 랩핑이 훼손된 경우 반품이 불가합니다.` }}</span>
        </li>
        <li class="desc_list">
          <span>{{
            `쿠폰을 사용한 주문을 취소/반품하여 쿠폰사용이 취소된 경우, 유효기간 내에서 재발급됩니다.`
          }}</span>
        </li>
        <li class="desc_list">
          <span>{{
            `단, 유효기간이 3일 미만으로 남았거나, 지난 경우에는 주문취소 완료일로부터 +3일로 1회에 한해서만 재발급됩니다.`
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { baseUri } from '@/store/constants.js'
import ReturnStep1 from '@/components/return/ReturnStep1'
import ReturnStep2 from '@/components/return/ReturnStep2'
import ReturnStep3 from '@/components/return/ReturnStep3'
import ReturnStep4 from '@/components/return/ReturnStep4'
export default {
  name: 'Return',
  components: {
    ReturnStep1,
    ReturnStep2,
    ReturnStep3,
    ReturnStep4
  },
  data() {
    return {
      stageNo: 4
    }
  },
  mounted() {
    if (baseUri) {
      if (!baseUri.indexOf('devqa')) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    prevStage(stageNo) {
      console.log(stageNo)
    },
    nextStage({ stageNo, stageVal }) {
      console.log(stageNo, stageVal)
    },
    completeReturn() {
      console.log('f')
    }
  }
}
</script>

<style lang="scss" scoped>
#request_return {
  background-color: #ffffff;
  width: 980px;
  margin: 252px auto 170px;
  border-radius: 12px;
  overflow: hidden;
  padding: 48px 53px;
}
.desc_wrap {
  .desc_list {
    padding-left: 6px;
    list-style: disc;
    list-style-position: inside;
    color: #36a5c2;
    height: 30px;
    line-height: 30px;
    .desc_list::marker {
      width: 4px;
    }
    span {
      font-size: 16px;
      color: #444444;
    }
  }
}
.box_wrap {
  width: 100%;
  .cart_progress {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    .progress_box {
      width: 100%;
    }
  }
}
.return_footer {
  padding: 40px;
  background-color: #f0f5fa;
  .return_msg {
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    margin-bottom: 16px;
  }
}
</style>
